import { render, staticRenderFns } from "./DashboardLayoutFooter.vue?vue&type=template&id=054eb8f7&scoped=true&"
import script from "./DashboardLayoutFooter.vue?vue&type=script&lang=ts&"
export * from "./DashboardLayoutFooter.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardLayoutFooter.vue?vue&type=style&index=0&id=054eb8f7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054eb8f7",
  null
  
)

export default component.exports